/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-24 12:22:34
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-24 12:52:40
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/Components/FontStyleSetting/index.tsx
 */
import React from 'react';
import { Icon } from '@/src/tools/icon';
import styles from './style.less';

function FontStyleSetting(props) {
  const { value, onChange } = props;
  return (
    <div className={styles.container}>
      <div className={styles.item}>
        <Icon
          className={styles.icon}
          onClick={() => onChange({ ...value, bold: !value.bold })}
          style={{ color: value?.bold ? '#38C568' : '#8C9196' }}
          type={value?.bold ? 'icona-bold-active' : 'icona-bold-inactive'}
        />
      </div>
      <div className={styles.item}>
        <Icon
          className={styles.icon}
          onClick={() => onChange({ ...value, italic: !value.italic })}
          style={{ color: value?.italic ? '#38C568' : '#8C9196' }}
          type={value?.italic ? 'icona-olique-active' : 'icona-olique-inactive'}
        />
      </div>
      <div className={styles.item}>
        <Icon
          className={styles.icon}
          onClick={() => onChange({ ...value, underline: !value.underline })}
          style={{ color: value?.underline ? '#38C568' : '#8C9196' }}
          type={
            value?.underline
              ? 'icona-underline-active'
              : 'icona-underline-inactive'
          }
        />
      </div>
    </div>
  );
}

export default FontStyleSetting;
